import { render, staticRenderFns } from "./DeliveryInstruction.vue?vue&type=template&id=0aef47fb&"
import script from "./DeliveryInstruction.vue?vue&type=script&lang=js&"
export * from "./DeliveryInstruction.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInstruction.vue?vue&type=style&index=0&id=0aef47fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports